var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"popover relative focus:outline-none",class:{
    'is-focused z-50': _vm.focused,
    static: !_vm.focused,
    [_vm.containerClass]: !!_vm.containerClass,
    'is-disabled': _vm.disabled,
  },attrs:{"tabindex":"0"},on:{"focus":_vm.open,"blur":_vm.popoverClose}},'div',_vm.$attrs,false),[_c('div',_vm._g({staticClass:"popover-trigger bg-transparent p-0"},_vm.$listeners),[_vm._t("default",null,null,{ open: _vm.open, close: _vm.close })],2),_vm._v(" "),_c('div',{ref:"content",staticClass:"popover-content mb-4 w-max min-w-full rounded bg-white shadow",class:[_vm.position, _vm.notchClass, _vm.contentWrapperClass]},[_vm._t("content",null,null,{ open: _vm.open, close: _vm.close })],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }